import Phaser from 'phaser';
import { LEVEL_COUNT, LEVELS } from '../../content/levels';
import type { GameMode } from '../types';
import { drawLevelBackground } from '../art';
import { audio } from '../systems/AudioManager';
import { configureLogicalCamera } from '../systems/DisplayManager';
import { introMusic } from '../systems/IntroMusic';
import { titleStyle } from './MenuScene';

interface PostcardData {
  mode: GameMode;
  levelIndex: number;
  score: number;
  bonus?: number;
}

export class PostcardScene extends Phaser.Scene {
  private payload!: PostcardData;

  constructor() {
    super('Postcard');
  }

  init(data: PostcardData): void {
    this.payload = data;
  }

  create(): void {
    configureLogicalCamera(this);
    const level = LEVELS[this.payload.levelIndex];
    drawLevelBackground(this, level);
    this.add.rectangle(240, 135, 480, 270, 0x07111d, 0.45);
    this.add.rectangle(240, 137, 430, 222, 0xf2dfb5, 0.97).setStrokeStyle(4, 0xd19b43);
    this.add.rectangle(240, 137, 398, 190, level.palette[0], 0.92).setStrokeStyle(2, level.palette[3]);
    this.add.text(240, 59, `PRZED TOBĄ · ETAP ${level.id}/${LEVEL_COUNT}`, titleStyle(8, '#efc65d')).setOrigin(0.5);
    this.add.text(240, 82, level.name.toUpperCase(), titleStyle(14, '#f6e5b6')).setOrigin(0.5).setStroke('#06111e', 4);
    this.add.text(240, 108, level.subtitle, titleStyle(8, '#8fd1b0')).setOrigin(0.5);
    this.add.text(240, 143, level.fact, {
      ...titleStyle(8, '#f0e9d0'),
      wordWrap: { width: 340 },
      align: 'center',
      lineSpacing: 5,
    }).setOrigin(0.5);
    const bonusCopy = this.payload.bonus ? `PREMIA Z POPRZEDNIEGO ETAPU +${this.payload.bonus}` : 'MIEJSKA POCZTÓWKA';
    this.add.text(240, 189, bonusCopy, titleStyle(8, '#efc65d')).setOrigin(0.5);
    this.add.text(240, 210, `WYNIK ${this.payload.score.toString().padStart(6, '0')}`, titleStyle(10, '#8fe17f')).setOrigin(0.5);
    this.add.text(240, 219, 'ENTER · ZACZNIJ ETAP', titleStyle(8, '#f6e5b6')).setOrigin(0.5);

    this.input.keyboard?.once('keydown-ENTER', () => this.continue());
    this.input.once('pointerdown', () => this.continue());
  }

  private continue(): void {
    audio.resume();
    introMusic.stop();
    this.scene.start('Game', {
      mode: this.payload.mode,
      levelIndex: this.payload.levelIndex,
      score: this.payload.score,
      multiplier: 1,
    });
  }
}
